import { useNavigate } from "react-router-dom";

import { Button } from "@/atoms/button/Button";

import { CartTopNav } from "../CartTopNav/CartTopNav";

export const CartBackButton = ({
  placeholder,
  showNavbar,
}: {
  placeholder: string;
  showNavbar: boolean;
}) => {
  const navigate = useNavigate();

  return (
    <>
      <CartTopNav showNavbar={showNavbar} />
      <div className="px-4">
        <div className="py-16 text-center font-serif text-h3">
          {placeholder}
        </div>
        <Button fullWidth={true} onClick={() => navigate("/shop")}>
          Explore treatments
        </Button>
      </div>
    </>
  );
};
